// extracted by mini-css-extract-plugin
module.exports = {"twitterButton":"MomentCardHeader_twitterButton__1js7G"};